export default function Footer() {
  return (
    <footer className="bg-carland-cream pt-16 pb-8">
      <div className="px-6 md:px-12 lg:px-20">
        {/* Main Footer Content */}
        <div className="bg-white rounded-3xl p-8 md:p-12 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            {/* Brand Column */}
            <div className="text-right">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-10 h-10 rounded-full bg-carland-dark flex items-center justify-center">
                  <span className="text-white font-pacifico text-lg">C</span>
                </div>
                <span className="text-xl font-bold text-carland-dark">کارلند</span>
              </div>
              <p className="text-carland-muted text-sm leading-relaxed mb-4">
                موسسه کاریابی کارلند از سال ۱۳۹۳ با ۱۳ سال سابقه درخشان در زمینه استخدام و کاریابی، متعهد به ایجاد امنیت شغلی پایدار برای کارجویان عزیز است.
              </p>
              <div className="space-y-2">
                <div className="flex items-center gap-2 text-sm text-carland-dark">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-line text-carland-accent"></i>
                  </div>
                  <span>carland@gmail.com</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-carland-dark">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-phone-line text-carland-accent"></i>
                  </div>
                  <span>۰۲۱-۱۲۳۴۵۶۷۸</span>
                </div>
                <div className="flex items-start gap-2 text-sm text-carland-dark">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-map-pin-line text-carland-accent"></i>
                  </div>
                  <span>تهران، خیابان ولیعصر، مرکز تجاری میلاد، طبقه ۱۵، واحد ۱۵۰۲</span>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="text-right">
              <h4 className="text-carland-dark font-bold text-sm mb-5">دسترسی سریع</h4>
              <ul className="space-y-3">
                <li><a href="/" className="text-carland-muted text-sm hover:text-carland-dark transition-colors duration-200">صفحه اصلی</a></li>
                <li><a href="#services" className="text-carland-muted text-sm hover:text-carland-dark transition-colors duration-200">خدمات</a></li>
                <li><a href="#licenses" className="text-carland-muted text-sm hover:text-carland-dark transition-colors duration-200">مجوزها</a></li>
                <li><a href="#contact" className="text-carland-muted text-sm hover:text-carland-dark transition-colors duration-200">تماس با ما</a></li>
              </ul>
            </div>

            {/* Rules & Policies */}
            <div className="text-right">
              <h4 className="text-carland-dark font-bold text-sm mb-5">قوانین</h4>
              <ul className="space-y-3">
                <li><a href="#" className="text-carland-muted text-sm hover:text-carland-dark transition-colors duration-200">قوانین و مقررات</a></li>
                <li><a href="#" className="text-carland-muted text-sm hover:text-carland-dark transition-colors duration-200">حریم خصوصی</a></li>
                <li><a href="#" className="text-carland-muted text-sm hover:text-carland-dark transition-colors duration-200">شرایط استفاده</a></li>
                <li><a href="#" className="text-carland-muted text-sm hover:text-carland-dark transition-colors duration-200">سوالات متداول</a></li>
              </ul>
            </div>

            {/* Support */}
            <div className="text-right">
              <h4 className="text-carland-dark font-bold text-sm mb-5">پشتیبانی</h4>
              <ul className="space-y-3">
                <li><a href="#" className="text-carland-muted text-sm hover:text-carland-dark transition-colors duration-200">راهنمای ثبت‌نام</a></li>
                <li><a href="#" className="text-carland-muted text-sm hover:text-carland-dark transition-colors duration-200">راهنمای کارجویان</a></li>
                <li><a href="#" className="text-carland-muted text-sm hover:text-carland-dark transition-colors duration-200">راهنمای کارفرمایان</a></li>
                <li><a href="https://t.me/CarLandSupport" target="_blank" rel="noopener noreferrer" className="text-carland-muted text-sm hover:text-carland-dark transition-colors duration-200">پشتیبانی تلگرام</a></li>
              </ul>

              {/* Social Icons */}
              <div className="flex gap-3 mt-6">
                <a href="https://t.me/CarLandSupport" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-carland-cream flex items-center justify-center text-carland-dark hover:bg-carland-dark hover:text-white transition-all duration-300 cursor-pointer">
                  <i className="ri-telegram-line"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-carland-cream flex items-center justify-center text-carland-dark hover:bg-carland-dark hover:text-white transition-all duration-300 cursor-pointer">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-carland-cream flex items-center justify-center text-carland-dark hover:bg-carland-dark hover:text-white transition-all duration-300 cursor-pointer">
                  <i className="ri-linkedin-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6 border-t border-carland-beige/50">
          <p className="text-carland-muted text-xs">
            © ۲۰۲۵ کارلند. تمامی حقوق محفوظ است.
          </p>
          <div className="flex items-center gap-4 text-xs text-carland-muted">
            <a href="#" className="hover:text-carland-dark transition-colors duration-200">حریم خصوصی</a>
            <span className="text-carland-beige">|</span>
            <a href="#" className="hover:text-carland-dark transition-colors duration-200">قوانین</a>
            <span className="text-carland-beige">|</span>
            <a href="#" className="hover:text-carland-dark transition-colors duration-200">کوکی‌ها</a>
          </div>
        </div>
      </div>
    </footer>
  );
}